export const threads = state => state.threads

export const currentThread = state => {
  return state.currentThreadID
    ? state.threads[state.currentThreadID]
    : {}
}

export const currentMessages = state => {
  const thread = currentThread(state)
  const messages = thread.messages ? thread.messages.map(function (group) {
    const groupMessages = {}
    groupMessages.time = group.time
    groupMessages.me = group.me
    groupMessages.name = group.name
    groupMessages.msgList = group.ids.map( id => state.messages[id])
    return groupMessages
  }) : []
  return messages
}


export const sortedMessages = (state, getters) => {
  const thread = currentThread(state)

  const messages = currentMessages(state)
  return messages.slice()
}


export const waitMessages = (state, getters) => {
  const thread = currentThread(state)
  return thread.waitMessages
}

export const waitGroupMessages = (state, getters) => {
  const thread = currentThread(state)
  const groupMessages = {}
  groupMessages.time = ''
  groupMessages.me = true
  groupMessages.name = ''
  groupMessages.msgList = thread.waitMessages
  return groupMessages
}

export const totalNewMessages = (state, getters) => {
  let result = 0
  const threads = state.threads
  for (const prop in state.threads) {
    if (threads.hasOwnProperty(prop)) {
      result += threads[prop].unreadCount || 0
    }
  }
  return result
}

export const isChineseText = state => state.lang === 'CHT'
export const isOpenChat = state => state.isOpenChat
export const isLoadedInitData = state => state.loadedInitData
export const isFocusInput = state => state.isFocusInput
export const currentThreadID = state => state.currentThreadID

export const isConnectFail = state => state.isConnectFail
export const isConnected = state => state.isConnected && !state.isConnectFail
export const isLoadingRoom = state => state.isLoadingRoom && state.isConnected && !state.isConnectFail
export const isLoadingMessage = state => state.isLoadingMessage && state.isConnected && !state.isConnectFail
